<template>
  <div class="app-container">
    <el-card>
      <div class="w-full flex justify-between">
        <div>
          <el-select
            v-model="table_params.params.advertiser_id"
            v-loading="advertiser.loading"
            placeholder="请选择广告投放账号"
            size="mini"
            clearable
            filterable
            @change="changeAdvertiser"
          >
            <el-option
              v-for="advertiser_item in advertiser.response"
              :key="advertiser_item.id"
              :label="advertiser_item.note"
              :value="advertiser_item.id"
            >
              {{ advertiser_item.label }}
              <span style="color:darkgray">{{ advertiser_item.note }}</span>
            </el-option>
          </el-select>
          <el-input
            v-model="table_params.params.name"
            style="width: 150px;margin-left: 10px"
            prefix-icon="el-icon-search"
            placeholder="渠道包名称搜索"
            clearable
            size="mini"
            class="search_input"
            @input="searchInput"
          />
          <el-input
            v-model="table_params.params.channel_id"
            style="width: 150px;margin:0 10px"
            prefix-icon="el-icon-search"
            placeholder="渠道包标识搜索"
            clearable
            size="mini"
            class="search_input"
            @input="searchInput"
          />
          <el-input
            v-model="table_params.params.game_name"
            style="width: 150px"
            prefix-icon="el-icon-search"
            placeholder="游戏名称搜索"
            clearable
            size="mini"
            class="search_input"
            @input="searchInput"
          />
        </div>
        <div>
          <el-popover
            placement="bottom"
            width="1000px"
            trigger="click"
          >
            <!-- 筛选盒子 -->
            <div class="filter_box">
              <!-- 游戏选项框 -->
              <div class="filter_item " style="width:400px;text-align: center">
                <p>所属游戏</p>
                <select-tree
                  class="extension_select"
                  :value="filter_obj.game_ids.value"
                  v-bind="filter_obj.game_ids.props"
                  v-on="filter_obj.game_ids.on"
                />
              </div>
              <div
                v-for="(item, index) in filters"
                :key="index"
                v-loading="item.loading"
                class="filter_item"
              >
                <p>{{ item.title }}</p>
                <div v-if="item.options.length" class="item">
                  <el-checkbox-group
                    v-model="table_params.params[item['fields']]"
                    @change="changeCheck"
                  >
                    <el-checkbox v-for="ele in item.options" :key="ele.label + ele.value" :label="ele.value">  {{ ele.label }} </el-checkbox>
                  </el-checkbox-group>
                </div>
                <el-empty v-else description="暂无数据" />
              </div>
            </div>
            <el-button slot="reference" type="text" icon="el-icon-set-up">筛选</el-button>
          </el-popover>
        </div>
      </div>
    </el-card>
    <el-card class="mt-20">
      <div class="w-full flex justify-between">
        <div>
          <label>批量操作：</label>
          <el-select
            v-model="batch_operate_config.value"
            size="mini"
            placeholder="选择需要批量的操作"
          >
            <el-option
              v-for="(item, index) in batch_operate_config.options"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button
            style="margin-left: 10px;"
            type="warning"
            size="mini"
            plain
            @click="batchExecute"
          >执行</el-button>
        </div>
        <div>
          <el-button icon="el-icon-s-operation" size="mini" type="primary" @click="pull_extend_package_show=true">同步渠道分包数据</el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="add_extend_package_show = true"
          >创建应用分包</el-button>
        </div>
      </div>
      <div style="padding: 20px 0" :class="[multiple_selection.length ? 'visible' : 'invisible']">已选择：{{ multiple_selection.length }}个/{{ table_params.response.page_info.total_number }}</div>
      <app-table
        ref="multipleTable"
        :table-key="extend_package_table_key"
        :tablep="table_params.params"
        :table-props="{ maxHeight: 500 }"
        :page-size="20"
        :page-sizes="[10, 15, 20, 50, 100]"
        :check="true"
        :get-data="getExtendPackageList"
        :is-row-click="true"
        :is-reserve-checked="true"
        @select-tr="handleSelectionChange"
      />
    </el-card>
    <!-- 同步渠道分包数据弹窗 -->
    <el-dialog
      title="同步渠道分包数据"
      :visible.sync="pull_extend_package_show"
      :before-close="closePullDialog"
      width="60%"
    >
      <pull-extend-package
        v-if="pull_extend_package_show"
        @config="configPullDialog"
        @cancel="closePullDialog"
      />
    </el-dialog>
    <!-- 创建应用分包弹窗 -->
    <el-dialog
      title="创建应用分包"
      :visible.sync="add_extend_package_show"
      :before-close="closeAddDialog"
      width="1160px"
    >
      <create-extend-package
        v-if="add_extend_package_show"
        @config="configAddDialog"
        @cancel="closeAddDialog"
      />
    </el-dialog>

    <!-- 更新应用分包弹窗 -->
    <el-dialog
      title="更新应用分包"
      :visible.sync="update_extend_package_show"
      :before-close="closeUpdateDialog"
      width="60%"
      class="update-extend-package-box"
    >
      <el-scrollbar style="height:500px">
        <update-extend-package
          v-if="update_extend_package_show"
          :form-model="form_model"
          @config="configUpdateDialog"
          @cancel="closeUpdateDialog"
        />
      </el-scrollbar>
    </el-dialog>

    <!-- 执行结果弹窗 -->
    <el-dialog
      :title="execute_result_config.title"
      :visible.sync="execute_result_config.show"
      width="60%"
    >
      <div v-if="execute_result_config.show">
        <el-alert
          :title="execute_result_config.message"
          type="success"
        />
        <div>
          <h2>创建成功：</h2>
          <app-table
            ref="success-result-table"
            :table-props="{}"
            :tablep="{ page: 1, limit: 10}"
            :table-key="result_table_key"
            :table-list-data="execute_result_config.success_results"
          />
        </div>
        <div style="margin-top: 30px">
          <h2>创建失败：</h2>
          <app-table
            ref="failed-result-table"
            :table-props="{}"
            :tablep="{ page: 1, limit: 10}"
            :table-key="result_table_key"
            :table-list-data="execute_result_config.failed_results"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ExtendPackageResource from '@/api/tool/extend-package/gdt';
const extendPackageResource = new ExtendPackageResource();

import AdvertisingResource from '@/api/advertising';
const advertisingResource = new AdvertisingResource();

import PromotedObject from '@/api/tool/promoted-object/gdt';
const promotedObject = new PromotedObject();

import ConfigResource from '@/api/config';
const configResource = new ConfigResource();

export default {
  name: 'GdtExtendPackage',
  components: {
    'app-table': () => import('@/components/app-table'),
    'pull-extend-package': () => import('./components/pull-extend-package'),
    'create-extend-package': () => import('./components/create-extend-package'),
    'update-extend-package': () => import('./components/update-extend-package'),
    'select-tree': () => import('@/components/select-tree'),
  },
  data() {
    return {
      /** 广告主ID */
      advertiser: {
        loading: false,
        params: {
          module: 'ad',
          key: 'gdt_pack_account',
        },
        response: [],
      },
      /** 应用ID */
      app: {
        loading: false,
        params: { is_list: 1, advertiser_id: '', promoted_object_type: 'PROMOTED_OBJECT_TYPE_APP_ANDROID' },
        response: { list: [] },
      },
      /** 执行结果表格头部 */
      result_table_key: require('./module/execute_result_table_key.js')(this),
      /** 执行结果弹窗配置 */
      execute_result_config: {
        /** 是否显示执行结果表格弹窗 */
        show: false,
        /** 执行失败结果集 */
        failed_results: {
          list: [],
          page_info: {
            total_number: 0,
            page: 1,
            page_size: 10,
            total_page: 4,
          },
        },
        /** 执行成功结果集 */
        success_results: {
          list: [],
          page_info: {
            total_number: 0,
            page: 1,
            page_size: 10,
            total_page: 4,
          },
        },
        /** 执行结果信息 */
        message: '',
      },
      /** 更新的表单model */
      form_model: { packages: [] },
      /** 是否显示同步渠道包数据弹窗 */
      pull_extend_package_show: false,
      /** 是否显示创建应用分包弹窗 */
      add_extend_package_show: false,
      /** 是否显示更新应用分包弹窗 */
      update_extend_package_show: false,
      /** 应用分包多选数据集 */
      multiple_selection: [],
      /** 应用分包表格头部 */
      extend_package_table_key: require('./module/extend-package-table-key.js')(this),
      /** 表格参数 */
      table_params: {
        loading: false,
        params: {
          advertiser_id: '',
          name: null,
          channel_id: null,
          game_name: null,
          game_ids: [],
          system_status: [],
          package_ids: [],
          page: 1,
          limit: 20,
        },
        response: {
          page_info: { total_number: 0 },
        },
      },
      /** 批量操作配置 */
      batch_operate_config: {
        options: [{ label: '更新', value: 'update' }],
        value: 'update',
      },
      /** 筛选项 */
      filters: {
        system_status: {
          loading: false,
          title: '渠道包状态',
          fields: 'system_status',
          options: Object.entries(require('./module/system-status-enum.js')(this)).map(([value, label]) => ({ value, label })),
        },
        package_ids: {
          loading: false,
          title: '应用',
          fields: 'package_ids',
          options: [],
        },
      },
      filter_obj: {
        /** 游戏 */
        game_ids: {
          label: '游戏',
          placeholder: '请选择游戏',
          props: {
            options: [],
            ischeckbox: true,
            'check-on-click-node': true,
            props: {
              value: 'id',
              label: 'name',
              children: 'children',
            },
            'select-props': {
              placeholder: '请选择游戏',
              clearable: true,
              accordion: true,
              size: 'small',
            },
          },
          on: {
            getcheckedValue: (game_ids) => {
              this.table_params.params.game_ids = game_ids;
              this.filter_obj.game_ids.value = game_ids;
              this.resetMultipleTable();
              this.updateTable();
            },
          },
          value: null,
        },
      },
    };
  },
  mounted() {
    this.getGameList({ refresh: 1 }).then((res) => {
      for (let i = 0; i < res.list.length; i++) {
        res.list[i]['disabled'] = true;
      }
      this.filter_obj.game_ids.props.options = res.list;
    });
  },
  created() {
    /** 获取广告主 */
    this.getConfigList().then((response) => {
      this.advertiser.response = response;
    });
  },
  methods: {
    /** 获取广告配置列表 */
    getConfigList: function() {
      this.advertiser.loading = true;
      return new Promise((resolve, reject) => {
        configResource
          .getConfigDataApi(this.advertiser.params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            this.advertiser.loading = false;
          });
      });
    },

    /** 获取应用列表 */
    getAppList() {
      this.app.loading = true;
      this.filters.package_ids.loading = true;
      promotedObject
        .getPromotedObject(this.app.params)
        .then((response) => {
          this.app.response = response;
          this.filters.package_ids.options = response.list.map(item => {
            return { label: item.promoted_object_name, value: item.type_id };
          });
        }).finally(() => {
          this.app.loading = false;
          this.filters.package_ids.loading = false;
        });
    },

    /** 处理应用分包多选 */
    handleSelectionChange(val) {
      this.multiple_selection = val;
    },

    /** 批量处理更新 */
    batchExecute() {
      if (!this.multiple_selection.length) {
        this.$message.warning('请先选择应用分包再操作');
        return;
      }
      this.update_extend_package_show = true;
      this.form_model.packages.splice(0);
      const rows = this.multiple_selection.map((item) => ({ ...item, isCollapse: false }));
      this.form_model.packages.push(...rows);
    },

    /** 获取游戏列表 */
    getGameList: function(params) {
      return new Promise((resolve, reject) => {
        advertisingResource
          .getGameListApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /** 处理搜索条件input改变时更新表格 */
    searchInput() {
      this.resetMultipleTable();
      this.updateTable();
    },

    /** 过滤搜索条件的空值 */
    filterParams() {
      const fields = ['name', 'channel_id', 'game_name'];
      fields.forEach(field => {
        if (this.table_params.params[field]?.trim() === '') {
          this.table_params.params[field] = null;
        }
      });
      if (!this.table_params.params['advertiser_id']) {
        this.table_params.params['advertiser_id'] = null;
      }
    },

    /** 重置已选中的表格行 */
    resetMultipleTable() {
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable?.deleteRows(this.multiple_selection);
        this.multiple_selection.splice(0);
      }
    },

    /** 获取应用分包列表 */
    getExtendPackageList() {
      this.filterParams();
      return new Promise((resolve, reject) => {
        extendPackageResource
          .getExtendPackageListApi(this.table_params.params)
          .then((response) => {
            this.table_params.response = response;
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /** 改变广告主 */
    changeAdvertiser(val) {
      this.app.response.list.splice(0);
      this.app.params.advertiser_id = val;
      this.filters.package_ids.options.splice(0);
      this.table_params.params.package_ids.splice(0);
      this.table_params.params.advertiser_id = val;
      if (this.app.params.advertiser_id) {
        this.getAppList();
      }
      this.filterParams();
      this.resetMultipleTable();
      this.updateTable();
    },

    /** 改变筛选项 */
    changeCheck() {
      this.resetMultipleTable();
      this.updateTable();
    },

    /** 更新表格 */
    updateTable() {
      if (this.$refs['multipleTable']) {
        this.$refs['multipleTable'].seekTable();
      }
    },

    /** 同步渠道分包数据确定 */
    configPullDialog() {
      this.updateTable();
      this.closePullDialog();
    },

    /** 创建应用分包确定 */
    configAddDialog(res) {
      this.updateTable();
      this.closeAddDialog();
      this.resetMultipleTable();
      this.showExecResult(res, '创建应用分包结果');
    },

    /** 显示执行结果 */
    showExecResult(res, title) {
      const { success_results, failed_results, message } = res;
      Object.assign(this.execute_result_config, { title, show: true, message });
      this.execute_result_config.success_results.list = success_results;
      this.execute_result_config.failed_results.list = failed_results;
      this.execute_result_config.success_results.page_info.total_number = success_results.length;
      this.execute_result_config.failed_results.page_info.total_number = failed_results.length;
    },

    /** 更新应用分包确定 */
    configUpdateDialog(res) {
      this.resetMultipleTable();
      this.updateTable();
      this.closeUpdateDialog();
      this.showExecResult(res, '更新应用分包结果');
    },

    /** 取消同步渠道分包数据 */
    closePullDialog() {
      this.pull_extend_package_show = false;
    },

    /** 取消创建应用分包 */
    closeAddDialog() {
      this.add_extend_package_show = false;
    },

    /** 取消更新应用分包 */
    closeUpdateDialog() {
      this.update_extend_package_show = false;
    },

    /** 单个更新渠道分包 */
    updateExtendPackage(row) {
      this.update_extend_package_show = true;
      this.form_model.packages.splice(0);
      this.form_model.packages.push({ ...row, isCollapse: false });
    },
  },
};
</script>

<style lang="scss" scoped>
.visible {
  visibility: visible;
}

.invisible {
  visibility: hidden;
}

/deep/ .update-extend-package-box .el-scrollbar__wrap {
  overflow-x: hidden;
}

.app-container {
  background: #f5f6f7;
  min-height: calc(100vh - 84px);
}

.filter_box {
  width: auto;
  height: 330px;
  background-color: #fff;
  .filter_item {
    width: 250px;
    height: 100%;
    overflow: auto;
    float: left;
    padding: 10px;
    border-right: 1px solid #dfe1e6;
    p {
      text-align: center;
      color: #939599;
    }
    .item {
      width: 100%;
      height: 270px;
      overflow: auto;
      .el-checkbox {
        display: block;
        width: 100%;
        height: 30px;
        line-height: 30px;
        white-space: nowrap;
      }
    }
  }
}

.extension_select{
  width: 350px;
}
</style>
